import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import ResourcesIcon from '../../img/resources.png';
import ToolkitIcon from '../../img/toolkit.png';
import FaqsIcon from '../../img/faqs.png';
import styles from './home.module.scss';

const HomeResources = () => {
    return (<>
        <div className={styles.dark}>
            <Container className={styles.mainContainer + ' ' + 'centerText' + ' ' + 'darkColors'}>
                <h3 className='mb-4'>AHRQ QI Resources</h3>
                <Row>
                    <Col xs={12} md={4} className='mb-4'>
                        <img src={FaqsIcon} />
                        <h4 className='my-2'>FAQs</h4>
                        <Link to="/faqs">Read the FAQs</Link>
                    </Col>
                    <Col xs={12} md={4} className='mb-4'>
                        <img src={ResourcesIcon} />
                        <h4 className='my-2'>Resources</h4>
                        <Link to="/resources">Explore the Resources</Link>
                    </Col>
                    <Col xs={12} md={4} className='mb-4'>
                        <img src={ToolkitIcon} />
                        <h4 className='my-2'>Toolkit for Hospitals</h4>
                        <Link to="/resources/toolkits">Get the Toolkit</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    </>)
}

export default HomeResources;